import { render, staticRenderFns } from "./ProjectBatchInfoView.vue?vue&type=template&id=866d5250&scoped=true"
import script from "./ProjectBatchInfoView.vue?vue&type=script&lang=js"
export * from "./ProjectBatchInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866d5250",
  null
  
)

export default component.exports